<template>
  <div class="wrap">
    <aliatica/>
    <viaducto/>
    <div class="d-flex justify-content-center my-5" >
      <div class="col-md-3 col-6">
        <img :src='"../assets/img/logo.png"' class="img-fluid" style="opacity: 0.5;">
      </div>
    </div>
    <circuito/>
    <div class="d-flex justify-content-center my-5" >
      <div class="col-md-3 col-6">
        <img :src='"../assets/img/logo.png"' class="img-fluid" style="opacity: 0.5;">
      </div>
    </div>
  </div>
</template>

<script>
import Aliatica from './aliatica'
import Viaducto from './viaducto'
import Circuito from './circuito'
export default {
  components: {
    Aliatica,
    Circuito,
    Viaducto
  },
  name: 'home',
};
</script>



// WEBPACK FOOTER //
// src/components/home.vue